module.exports = __webpack_public_path__ + "img/landing-page-4.4e983497.webp";